import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Location } from '@angular/common';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private location: Location) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      headers: request.headers.set('Authorization', `Bearer ${this.authService.readToken()}`)
    });

    return next.handle(request).pipe(
      catchError((err, caught) => {
        if (err.status === 401) {
          this.authService.redirectUrl = !this.location.path().includes('/auth') ? this.location.path() : '';
          this.handleAuthError();
          return of(err);
        }
        throw err;
      })
    );
  }

  private handleAuthError() {
    this.authService.logout();
  }
}
